module.exports = __webpack_public_path__ + "8c35bf54c505d32035cafd344d316bb9.png";